import { render, staticRenderFns } from "./CommentViewAttachements.vue?vue&type=template&id=1276ebd2&scoped=true"
import script from "./CommentViewAttachements.vue?vue&type=script&lang=js"
export * from "./CommentViewAttachements.vue?vue&type=script&lang=js"
import style0 from "./CommentViewAttachements.vue?vue&type=style&index=0&id=1276ebd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1276ebd2",
  null
  
)

export default component.exports